import { TimeDeviationDialogState } from './time-deviation-dialog.state';

/**
 * Initialer State für den Time-Deviation-Dialog.
 */
export const timeDeviationDialogStateInitial: TimeDeviationDialogState = {
  isOpen: false,
};
